export const COLORS = {
    primary: '#00ADEE',
    primaryDark: '#1976d2',
    error: '#D91C24',
    warning: '#FF9800',
    success: '#4CAF50',
    textPrimary: '#333',
    textSecondary: '#666',
    backgroundLight: '#F5F8F9',
    donut: ['#D91C24', '#00ADEE', '#7098da', '#34D399', '#A78BFA', '#FB923C', '#60A5FA'],
};

export default COLORS;